import Icon from 'veui/components/Icon'

Icon.register({
  link: {
    paths: [
      {
        d: 'M245.24 714.76A192 192 0 01109.47 387L200 296.49a32 32 0 1145.26 45.26l-90.51 90.5a128 128 0 00181 181l90.5-90.51A32 32 0 01471.51 568L381 658.53a190.75 190.75 0 01-135.76 56.23zM569 470.51L659.53 380A192 192 0 00388 108.47L297.49 199a32 32 0 1045.26 45.26l90.51-90.51a128 128 0 01181 181l-90.51 90.5A32 32 0 00569 470.51zm-275.51 49.25l227-227a32 32 0 10-45.25-45.25l-227 227a32 32 0 1045.25 45.25z'
      }
    ],
    width: '768',
    height: '768'
  }
})
